import { render, staticRenderFns } from "./people_two.vue?vue&type=template&id=5cbbecf6&scoped=true&"
import script from "./people_two.vue?vue&type=script&lang=js&"
export * from "./people_two.vue?vue&type=script&lang=js&"
import style0 from "./people_two.vue?vue&type=style&index=0&id=5cbbecf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbbecf6",
  null
  
)

component.options.__file = "people_two.vue"
export default component.exports